import {
  loginService,
  superAdminloginService,
  socialLoginService,
  getUserDynamicFieldsService,
  saveUserDynamicFieldsService,
  getSSOLoginUrlService,
  ssoCallbackService,
  ssoLogoutService,
  ssoRefreshTokenService,
} from "../../services/api";
import {
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  SOCIAL_LOGIN_FAIL,
  SOCIAL_LOGIN_SUCCESS,
  SUPERADMIN_LOGIN_SUCCESS,
  SUPERADMIN_LOGIN_FAIL,
  GET_USER_DYNAMIC_FIELD_SUCCESS,
  GET_USER_DYNAMIC_FIELD_FAIL,
  SSO_LOGIN_URL_SUCCESS,
  SSO_LOGIN_URL_FAIL,
  SOCIAL_SSO_LOGIN_SUCCESS,
  SOCIAL_SSO_LOGIN_FAIL,
  SSO_LOGOUT_SUCCESS,
  SSO_LOGOUT_FAIL,
  SSO_REFRESH_SUCCESS,
  SSO_REFRESH_FAIL,
} from "../actionTypes";

export const login = (username, password) => (dispatch) => {
  return loginService(username, password).then(
    (data) => {
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user: data },
      });
      return Promise.resolve(data);
    },
    (error) => {
      dispatch({
        type: LOGIN_FAIL,
      });
      return Promise.reject(error);
    },
  );
};

export const superAdminlogin = (username, password) => (dispatch) => {
  return superAdminloginService(username, password).then(
    (data) => {
      dispatch({
        type: SUPERADMIN_LOGIN_SUCCESS,
        payload: { user: data },
      });
      return Promise.resolve(data);
    },
    (error) => {
      dispatch({
        type: SUPERADMIN_LOGIN_FAIL,
      });
      return Promise.reject(error);
    },
  );
};

export const socialLogin =
  (
    { code, verifier = "", name },
    inviteType,
    workspaceId,
    token,
    priceLookupKey,
  ) =>
  (dispatch) => {
    return socialLoginService(
      code,
      verifier,
      name,
      inviteType,
      workspaceId,
      token,
      priceLookupKey,
    ).then(
      (data) => {
        dispatch({
          type: SOCIAL_LOGIN_SUCCESS,
          payload: { user: data },
        });
        return Promise.resolve(data);
      },
      (error) => {
        dispatch({
          type: SOCIAL_LOGIN_FAIL,
        });
        return Promise.reject(error);
      },
    );
  };

export const ssoLoginAction = (redirectUri) => (dispatch) => {
  return getSSOLoginUrlService(redirectUri).then(
    (data) => {
      dispatch({
        type: SSO_LOGIN_URL_SUCCESS,
        payload: data,
      });
      return Promise.resolve(data);
    },
    (error) => {
      dispatch({
        type: SSO_LOGIN_URL_FAIL,
      });
      return Promise.reject(error);
    },
  );
};

export const ssoLogoutAction = (redirectUri) => (dispatch) => {
  return ssoLogoutService(redirectUri).then(
    (data) => {
      dispatch({ type: SSO_LOGOUT_SUCCESS, payload: data });
      return Promise.resolve(data);
    },
    (error) => {
      dispatch({ type: SSO_LOGOUT_FAIL });
      return Promise.reject(error);
    },
  );
};
export const ssoCallbackAction =
  (
    authorizationCode,
    redirectUri,
    workspaceId,
    priceLookupKey,
    inviteToken,
    inviteType,
    codeVerifier,
  ) =>
  (dispatch) => {
    return ssoCallbackService(
      authorizationCode,
      redirectUri,
      workspaceId,
      priceLookupKey,
      inviteToken,
      inviteType,
      codeVerifier,
    ).then(
      (data) => {
        dispatch({
          type: SOCIAL_SSO_LOGIN_SUCCESS,
          payload: { user: data },
        });
        return Promise.resolve(data);
      },
      (error) => {
        dispatch({
          type: SOCIAL_SSO_LOGIN_FAIL,
        });
        return Promise.reject(error);
      },
    );
  };
export const LOGOUT = "LOGOUT";
export const getUserDynamicFields = (id, userid) => (dispatch) => {
  return getUserDynamicFieldsService(id, userid).then(
    (data) => {
      dispatch({
        type: GET_USER_DYNAMIC_FIELD_SUCCESS,
        payload: { user: data.body },
      });
      return Promise.resolve(data);
    },
    (error) => {
      dispatch({
        type: GET_USER_DYNAMIC_FIELD_FAIL,
      });
      return Promise.reject(error);
    },
  );
};

export const saveUserDynamicFields =
  ({ dynamicfields }) =>
  (dispatch) => {
    return saveUserDynamicFieldsService({ dynamicfields }).then(
      (data) => {
        dispatch({
          type: GET_USER_DYNAMIC_FIELD_SUCCESS,
          payload: { user: data.body },
        });
        return Promise.resolve(data);
      },
      (error) => {
        dispatch({
          type: GET_USER_DYNAMIC_FIELD_FAIL,
        });
        return Promise.reject(error);
      },
    );
  };

export const ssoRefreshTokenAction = (memberId) => (dispatch) => {
  const attempt = () => ssoRefreshTokenService(memberId);

  return attempt()
    .catch((error) => {
      console.error("SSO token refresh failed, retrying...", error);
      return attempt();
    })
    .then(
      (data) => {
        dispatch({
          type: SSO_REFRESH_SUCCESS,
          payload: data,
        });
        return Promise.resolve(data);
      },
      (error) => {
        console.error("SSO token refresh failed after retry:", error);
        dispatch({
          type: SSO_REFRESH_FAIL,
        });
        return Promise.reject(error);
      },
    );
};